import React, { useState } from "react";
import Draggable from "react-draggable";
import { CloseOutlined } from "@ant-design/icons";
import { Modal, Button } from "antd";
import EmployeeSchedulingTable from "./EmployeeSchedulingTable";

const EmployeeSchedulingModal = (props) => {
  const { employee, startDate, endDate, onHide, visible } = props;
  const [disabled, setDisabled] = useState(true);

  const onCancel = () => {
    onHide();
  };

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div>
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          className="header"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <div
          style={{
            padding: "40px",
          }}
        >
          {visible && (
            <EmployeeSchedulingTable
              startDate={startDate}
              endDate={endDate}
              employee={employee}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EmployeeSchedulingModal;
